import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jk6ud2cvvc: FaireBrandEntity = {
  token: "b_jk6ud2cvvc",
  type: "brand",
  name: "Eastern Off Price",
  avatarUrl:
    "https://cdn.faire.com/fastly/39bdd501fea8c5448928110ff5dddcaa3e9e3399ad0b32054cc833e87b53e229.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0b2399ab59922d31d6173e4e919a53a9e0e4ea769e7c84cb8ee73313725a7230.png",
  logoUrl:
    "https://cdn.faire.com/fastly/39bdd501fea8c5448928110ff5dddcaa3e9e3399ad0b32054cc833e87b53e229.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0b2399ab59922d31d6173e4e919a53a9e0e4ea769e7c84cb8ee73313725a7230.png",
  location: "EAST HANOVER, NJ, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 144,
  isInsider: true,
  description:
    "Eastern Off Price is a 4th generation family business established in 1947.   Eastern Off Price offers The Norty Brand products open stock by size and color.  Eastern Specializes in buying Off-Price, Closeouts and Liquidations of both name brand children's apparel and opening price point apparel.   We merchandise these buys in our warehouses to provide our resellers with unique items that can now be purchased open stock by size.   We believe in quality, value and service.   Thank you for giving us the opportunity to serve your business!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:06.034Z",
    importedBy: "entity-db-cli",
  },
};
